import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Fires when a user successfully verifies their new email address (for email changes, not sign-ups)',
  name: 'email_change_verified',
  params: [
    {
      description: 'The id of the user changing their email',
      name: 'user_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The previous email address before the change',
      name: 'old_email',
      required: true,
      type: 'string',
    },
    {
      description: 'The new email address after successful verification',
      name: 'new_email',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
